export default __webpack_public_path__ + "fonts/WarnerBrosSans-Bold.ttf";